// بيانات المواطنين الأساسية مع الملفات السلوكية
export const initialCitizens = [
  {
    id: 1,
    name: "أحمد محمد",
    licenseExpiry: "2025-11-20",
    lastComplaint: null,
    sector: "العمل",
    proactiveActions: [],
    profileType: "worker_license",  // ← مرتبط بالملف السلوكي
    phone: "0501234567",
    email: "ahmed.m@email.com"
  },
  {
    id: 2,
    name: "فاطمة علي",
    licenseExpiry: null,
    lastComplaint: "2025-10-15",
    complaintType: "عنف أسري",
    complaintCount: 2,
    sector: "التنمية الاجتماعية",
    proactiveActions: [],
    profileType: "domestic_violence_victim",  // ← مرتبط بالملف السلوكي
    phone: "0509876543",
    email: null, // قد لا يكون لديها بريد
    hasChildren: true,
    childrenCount: 2
  },
  {
    id: 3,
    name: "خالد سعيد",
    salaryDate: "25",
    currentDay: "28",
    sector: "العمل",
    lastComplaint: "2025-09-27",
    proactiveActions: [],
    profileType: "salary_delayed",  // ← مرتبط بالملف السلوكي
    phone: "0551122334",
    email: "khaled.s@email.com",
    company: "شركة البناء الحديث"
  }
];

// إشعارات بوابة المواطن (محدثة مع التخصيص)
export const initialCitizenNotifications = [
  {
    id: 1,
    type: 'protection',
    priority: 'critical',
    title: 'رسالة دعم من وزارة التنمية الاجتماعية',
    message: 'مرحباً فاطمة. نحن هنا لحمايتك ودعمك. كل ما تشاركينه معنا سري تماماً. فريقنا المتخصص على استعداد للتواصل معك في الوقت المناسب لك (10 صباحاً - 2 ظهراً). أنتِ لست وحدك. 🛡️',
    action: 'اتصلي بنا على 1919 أو اضغطي للمحادثة المباشرة',
    timestamp: new Date().toISOString(),
    read: false,
    icon: '🛡️',
    personalizedFor: 'domestic_violence_victim'
  },
  {
    id: 2,
    type: 'followup',
    priority: 'high',
    title: 'متابعة حالتك - أخصائية متخصصة',
    message: 'تم تعيين الأخصائية الاجتماعية سارة أحمد لمتابعة حالتك. سيتم التواصل معك غداً في تمام الساعة 11:00 صباحاً (الوقت المناسب لك). يمكنك تأجيل الموعد إذا احتجت.',
    action: 'عرض التفاصيل',
    timestamp: new Date(Date.now() - 3600000).toISOString(),
    read: false,
    icon: '📞',
    personalizedFor: 'domestic_violence_victim'
  },
  {
    id: 3,
    type: 'services',
    priority: 'high',
    title: 'خدمات الدعم المتاحة لك الآن',
    message: 'بناءً على حالتك، هذه الخدمات متاحة لك فوراً:\n• إيواء آمن (متاح 24/7)\n• دعم نفسي متخصص\n• استشارة قانونية مجانية\n• دعم مالي طارئ',
    action: 'استعراض الخدمات',
    timestamp: new Date(Date.now() - 7200000).toISOString(),
    read: true,
    icon: '💼',
    personalizedFor: 'domestic_violence_victim'
  },
  {
    id: 4,
    type: 'safety',
    priority: 'critical',
    title: 'خطة الأمان الشخصية',
    message: 'قمنا بإعداد خطة أمان مخصصة لك تتضمن:\n• أرقام طوارئ سريعة\n• أقرب مركز إيواء (2 كم)\n• خط ساخن مخصص لك\n• إجراءات الحماية العاجلة',
    action: 'عرض خطة الأمان',
    timestamp: new Date(Date.now() - 10800000).toISOString(),
    read: false,
    icon: '🚨',
    personalizedFor: 'domestic_violence_victim'
  }
];

// أمثلة الشكاوى للمحاكي
export const complaintExamples = [
  "والله أنا في وضع صعب. فيه عنف وضرب وأنا خايفة على أطفالي",
  "رجع صار نفس الشي... الوضع أسوأ من قبل والعنف زاد",
  "رخصتي انتهت ولم أتمكن من تجديدها",
  "راتبي ما وصل من شهرين وأنا محتاج",
  "معاملتي متأخرة من 3 أسابيع"
];